<template>
    <div class="contacto">
            <div class="main col-lg-12" >
                <h5 class="col-lg-12">Panel de Artículos.</h5>
                
                <div class="container text-right" id="top">
                  <b-button pill v-b-modal.post-modal class="btnAdd"><i class="fa fa-plus mr-3"></i> Crear Post</b-button>
                    <Articulos ref="articulos"/>
                </div>
                <br>

  

    <b-modal ref="post-modal" id="post-modal" no-close-on-backdrop scrollable hide-header>
     <div class="d-block text-center">
        <div class="col-lg-12">
                  <h2>{{form_title}}</h2>
                   <ValidationObserver ref="form" >
                        <b-form id="form" class="form-container">
                        <div class="form-group">
                            <label for="txtTitulo">Titulo</label>
                            <ValidationProvider rules="required|max:200"  v-slot="{ errors }">
                                <b-form-input v-model="form.txtTitulo" name="txtTitulo" type="text" placeholder="Titulo"/>
                                <span class="error">{{ errors[0] }}</span>
                            </ValidationProvider>
                        </div>
                         <div class="form-group">
                            <label for="message">Introduccion</label>
                            <ValidationProvider rules="required|max:200"  v-slot="{ errors }">
                                <b-form-textarea v-model="form.txtIntroduccion" rows="3" name="txtIntroduccion"/>
                                <span class="error">{{ errors[0] }}</span>
                            </ValidationProvider>
                        </div>
                        <div class="form-group text-right">
                          <label for="prevImage">Imagen</label>
                          <div name="prevImage" class="postImage mb-3">
                            <img :src="form.prevImagen"/>
                          </div>
                          <b-button variant="info" pill @click="openLoad()" class="btnSend"><b-icon icon="upload" class="mr-2"></b-icon>Cargar Imagen</b-button>
                          <ValidationProvider  rules=""  v-slot="{ errors }">
                            <input type="file" id="fileImage" @change="loadFile($event)" hidden/>
                            <br>
                            <span class="error">{{ errors[0] }}</span>
                            </ValidationProvider>
                        
                          <input type="text" id="imagenAnterior" :src="form.prevImage" hidden/>
                        </div>
                        <div class="form-group">
                            <label for="txtPublicationDate">Fecha de Publicación</label>
                            <ValidationProvider rules="max:10"  v-slot="{ errors }">
                                <b-form-input v-model="form.txtPublicationDate" min="1920-01-01" max="2999-12-31" name="txtPublicationDate" placeholder="dd/mm/aaa" type="date"/>
                                <span class="error">{{ errors[0] }}</span>
                            </ValidationProvider>
                        </div>
                         <div class="form-group">
                            <label for="message">Descripción</label>
                            <ValidationProvider v-slot="{ errors }">
                                <b-form-textarea v-model="form.txtDescripcion" rows="6" name="txtDescripcion"  placeholder=""/>
                                <span class="error">{{ errors[0] }}</span>
                            </ValidationProvider>
                        </div>
                       
                        <div class="form-group">
                          <label for="categoria">Categoría</label>
                          <ValidationProvider rules="required"  v-slot="{ errors }">
                            <b-form-select v-model="form.categoria_id" id="slcCategoria">
                              <option v-for="cat in categorias" :value="cat.id" :key="cat.value">{{cat.nombre}}</option>
                            </b-form-select>
                            <span class="error">{{ errors[0] }}</span>
                          </ValidationProvider>
                        </div> <hr/>
                        <div class="form-group text-left">
                            <label>Post publico</label>
                            <b-form-checkbox type="checkbox" v-model="form.post_activo"></b-form-checkbox>
                        </div>
                        <div class="form-group text-left">
                            <label>Fijo</label>
                            <b-form-checkbox type="checkbox" v-model="form.post_fijo"></b-form-checkbox>
                        </div>
                        <div class="form-group text-left">
                          <label for="rbtTipo">Tipo</label>
                          <ValidationProvider rules="required"  v-slot="{ errors }">
                            <b-form-radio v-model="form.tipo_post" name="rbtTipo" value="post">Post</b-form-radio>
                            <b-form-radio v-model="form.tipo_post" name="rbtTipo" value="otro">Otro</b-form-radio>
                            <span class="error">{{ errors[0] }}</span>
                          </ValidationProvider>
                        </div>
                    </b-form>
                    </ValidationObserver>
        </div>
      </div>
    <template #modal-footer="{}">
      <!-- Emulate built in modal footer ok and cancel button actions -->
      <b-button v-show="!loading && !editing" type="submit" pill class="btnSend " @click="onSubmit()">Guardar</b-button>
      <b-link v-show="!loading && !editing" class="btnCancel" @click="$refs['post-modal'].hide();"></b-link>
      <b-button v-show="!loading && editing" type="submit" pill class="btnSend " @click="onSubmit()">Guardar Cambios</b-button>
      <b-link v-show="!loading && editing" class="btnCancel" @click="reset();"></b-link>
      <b-button v-show="loading" class="btnSend" pill disabled="disabled"><b-spinner small class="mr-2"></b-spinner>ENVIANDO</b-button>
    </template>
  </b-modal>
                <!--main-center"-->
            </div><!--main-->
    </div>
</template>

<script>

import env from '@/plugins/enviroment';
import contactoApi from "../api/contacto";
import categoriasApi from "../api/categorias"
import postsApi from "../api/posts";
import Articulos from '@/components/articulos-panel.vue'
import {ValidationProvider,ValidationObserver} from 'vee-validate';
import {mapState,mapActions} from "vuex";
import Notify from "@/plugins/notify";
import Swal from "sweetalert2";


export default {
  name: 'post-manager',
  components: {
      ValidationProvider,
      ValidationObserver,
      Articulos
  },
  data() {
      return {
        form_title:"Nuevo Post",
        categorias:[],
        form :{
            id_post:null,
            txtTitulo   : '',
            txtIntroduccion      : '',
            txtDescripcion     : '',
            prevImagen     : '/static/images/no-image-default.png',
            imgImagen     : null,
            txtPublicationDate    : '',
            categoria_id:null,
            tipo_post:null,
            post_activo:true,
            post_fijo:false
        },
        show            : true,
        loading:false,
        editing:false,
      }
    },
    
    computed: {
        ...mapState("posts",["id",
                             "categoria_id",
                             "titulo",
                             "introduccion",
                             "descripcion",
                             "imagen",
                             "tipo",
                             "fecha_publicacion",
                             "activo",
                             "fijo"]),
        ...mapState("menu",["principal"]),
        ...mapState("auth",["logged"])
    },
    watch: {
      id(newValue, oldValue) {
        if(newValue != null)
        this.fillEditForm();
      }
    },
    methods: {
      ...mapActions("menu",["setMenu"]),
      ...mapActions("posts",["clearPost"]),
      addPost(){
        this.$refs['post-modal'].show();
      },
      fillEditForm(){
        this.$refs['post-modal'].show();
        
        this.editing = true;
        this.form.id_post = this.id;
        this.form_title = "Editar Post";
        this.form.txtTitulo = this.titulo; 
        this.form.txtIntroduccion = this.introduccion; 
        this.form.imgImagen = env.baseURL + this.imagen;
        this.form.prevImagen = env.baseURL + this.imagen;
        this.form.txtPublicationDate = this.fecha_publicacion;
        this.form.txtDescripcion = this.descripcion; 
        this.form.categoria_id = this.categoria_id;
        this.form.tipo_post = this.tipo;
        this.form.post_activo = this.activo;
        this.form.post_fijo = this.fijo;
      },
      openLoad(){
        document.getElementById("fileImage").click();
      },
      loadFile(e){
        let self = this;
        let file = e.target.files[0];
        let reader = new FileReader();
        console.log(file);
        reader.readAsDataURL(file);
        var sizeByte = file.size;
        var siezeMegaByte = parseInt(sizeByte / (1024*1024));

        if(siezeMegaByte > 2){
           Notify.WarningToast('El tamaño máximo de la imagen es de: 2MB');
           return;
        }

        reader.onload =  function() {
          self.form.imgImagen = file;
          self.form.prevImagen = reader.result;
          
        };
      },
      onSubmit(){
  
        if(this.editing){
            this.updatePost();
          }else{
            this.postPost();
          }
      },
      getCategorias(){
      /*
      -PARAMETROS PERMITIDOS-
        nombre=conta
        activo=true
        paginate=true
        items_to_show=10
        order=asc
        order_by=id
        -------------------------*/

      let parametros = {paginate:false,items_to_show:10,order:"asc",order_by:"id"};
      categoriasApi
      .getCategorias(parametros)
      .then(response => {
        this.categorias = response.data.data;
      }).catch(err => {
        console.log("Ocurrio un error al cargar las categorías.");
      });
    },
    async postPost(){
      var isValid = await this.$refs.form.validate();
      if (!isValid) {
        Notify.WarningToast("Verifique que los campos obligatorios estén completos.");
      }else{
        this.loading = true;
        let parametros = this.form;
        let formData = new FormData();
        let activo = 0;
        let fijo = 0;

        if(parametros.post_activo){
          activo=1;
        }

        if(parametros.post_fijo){
          fijo=1;
        }

        formData.append("titulo",parametros.txtTitulo);
        formData.append("introduccion",parametros.txtIntroduccion);
        formData.append("imagen",parametros.imgImagen);
        formData.append("fecha_publicacion",parametros.txtPublicationDate.toString());
        formData.append("descripcion",parametros.txtDescripcion);
        formData.append("categoria_id",parametros.categoria_id);
        formData.append("activo",activo);
        formData.append("fijo",fijo);
        formData.append("tipo",parametros.tipo_post);
        
       await postsApi
          .createPost(formData)
          .then(response => {
            Notify.Success("¡Excelente!", "El artículo: "+parametros.txtTitulo+", se agrego con éxito.");
            this.reset();
            this.$refs['post-modal'].hide();
            this.$refs.articulos.getPosts();
          }).catch(err => {
            if(err.response.data.error != undefined)
              Notify.Error("No pudimos guardar los cambios", "",err.response.data.error);
            else
              Notify.Error("No eres tu, somos nostros.", "","Lo sentimos, en este momento no fue posible actualizar el artículo, inténtalo nuevamente.");
          });
      }
      this.loading = false;
    },
    async updatePost(){
     var isValid = await this.$refs.form.validate();
      if (!isValid) {
        Notify.WarningToast("Verifique que los campos obligatorios estén completos.");
      }else{
        this.loading = true;
        let parametros = this.form;
        let formData = new FormData();
        let activo = 0;
        let fijo = 0;

        if(parametros.post_activo){
          activo=1;
        }

        if(parametros.post_fijo){
          fijo=1;
        }
        formData.append("id",parametros.id_post);
        formData.append("titulo",parametros.txtTitulo);
        formData.append("introduccion",parametros.txtIntroduccion);

        if(parametros.imgImagen != parametros.prevImagen)
          formData.append("imagen",parametros.imgImagen);

        formData.append("fecha_publicacion",parametros.txtPublicationDate.toString());
        formData.append("descripcion",parametros.txtDescripcion);
        formData.append("categoria_id",parametros.categoria_id);
        formData.append("activo",activo);
        formData.append("fijo",fijo);
        formData.append("tipo",parametros.tipo_post);
        
       await postsApi
          .updatePost(formData)
          .then(response => {
            Notify.Success("¡Excelente!", "El artículo: "+parametros.txtTitulo+", se actualizó con éxito.");
            this.reset();
            this.$refs['post-modal'].hide();
            this.$refs.articulos.getPosts();
          }).catch(err => {
            if(err.response.data.error != undefined)
              Notify.Error("No pudimos guardar los cambios", "",err.response.data.error);
            else
              Notify.Error("No eres tu, somos nostros.", "","Lo sentimos, en este momento no fue posible actualizar el artículo, inténtalo nuevamente.");
          });
      }
      this.loading = false;
    },
    reset() {
      this.clearPost();
       
      this.form ={
            id_post:null,
            txtTitulo:'',
            txtIntroduccion:'',
            txtDescripcion:'',
            txtPublicationDate:'',
            categoria_id:null,
            tipo_post:null,
            post_activo:true,
            post_fijo:false
        },
        
      this.$nextTick(() => {
          
          this.$refs.form.reset();
          this.form_title = "Nuevo Post";
          this.editing = false;
          this.form.imgImagen = null;
          this.form.prevImagen = "/static/images/no-image-default.png";
          this.$refs['post-modal'].hide();
          window.location = "#top";
        });
      },
    isMobile(){
      var check = false;
      //console.log(window.screen.width);
      if(window.screen.width < 769){
        return check=true;
      }
    },
    init(){
      document.body.scrollTop = 0; // For Safari
      document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera;
      this.getCategorias();

      this.setMenu(true);
    }
    },
    created () {
      this.init();
    },
}
</script>

<style scoped>
h2{
  font-family: Muli;
  font-style: normal;
  font-weight: normal;
  font-size: 24px;
  line-height: 50px;
  align-items: center;
  text-align: center;
  letter-spacing: 0.2px;
  color: #1E2245;
}

.postImage img{
  width: 100%;
  border-radius: 10px;
  border: 1px solid #ced3da;
}
.google-terms{
     margin:15px;
    font-family: Muli;
    font-style: normal;
    font-weight: 600;
    font-size: 10px;
    line-height: 15px;
    color: #828282;
}
.error{
    font-family: Muli;
    font-style: normal;
    font-size: 12px;
    color:red;
}
    h5 {
        font-family: Muli;
        font-style: normal;
        font-size: 38px;
        line-height: 18px;

        align-items: center;
        text-align: center;
        letter-spacing: 0.2px;
        color: #1E2144;

        margin: 100px 0px;
    }
    .btnAdd {
    font-family: Muli-Bold;
    font-style: normal;
    font-size: 14px;
    line-height: 18px;
    letter-spacing: 0.3px;
    background:#1E2245;
    border-color:#1E2245!important;
    border-radius: 18px;
    color: #FFFFFF;
    margin-top: 30px;
    padding: 13px 27px;
  }
  .btnAdd > i{
    color:#2DB9D1;
  }

  .btnAdd:hover {
    color: #FFFFFF;
    background-color: #4F4C4C;
    border-color: #4d4c4f !important;
  }

  .btnSend {
    font-family: Muli-Bold;
    font-style: normal;
    font-size: 14px;
    line-height: 18px;
    letter-spacing: 0.3px;
    background: #2DB9D1;
    border-color: #2DB9D1 !important;
    border-radius: 18px;
    color: #FFFFFF;
    display: block;
    padding: 13px 40px;
  }

  .btnCancel {
    content: url("/static/images/icons/cancel.svg");
    font-family: Muli-Bold;
    font-style: normal;
    font-size: 14px;
    line-height: 18px;
    letter-spacing: 0.3px;
    border-radius: 150px;
    background-color: #F2F2F2;
    border-color: #F2F2F2;
    display: block;
    padding:16px;
    transition:0.2s;
  }

  .btnSend:hover {
    color: #FFFFFF;
    background-color: #4F4C4C;
    border-color: #4d4c4f !important;
  }
  .btnCancel:hover {
    color: #FFFFFF;
    background-color: #4F4C4C;
    border-color: #4d4c4f !important;
  }

  .cliker-text{
      color:#2DB9D1;
  }

    .main{
        padding: 40px 0;
        background:  url("/static/images/bg_azul_categoria.svg") repeat-x;
    }
    .main input {
        font-size: 11px;
        padding-top: 3px;
        border: 1px solid #E0E0E0;
        border-radius: 5px;
    }
    .main-center{
        margin-top: 30px;
        margin-bottom: 120px !important;
        margin: 0 auto;
        max-width: 600px;
        padding: 10px 40px;
        background:#FFFFFF;
        text-shadow: none;
        -webkit-box-shadow: 1px 10px 20px rgba(107, 127, 153, 0.2);
        -moz-box-shadow: 1px 10px 20px rgba(107, 127, 153, 0.2);
        box-shadow: 1px 10px 20px rgba(107, 127, 153, 0.2);
        border-radius: 25px;
    }

    .form-container {
        padding: 30px 0px;
    }

    .form-group > label {
        font-family: Muli-Light;
        font-style: normal;
        font-size: 14px;
        line-height: 30px;

        display: flex;
        align-items: center;
        text-align: center;
        letter-spacing: 2px;
        color: #1E2144;
    }
    .placeholder {
        font-family: Muli-Light;
        font-style: normal;
        font-size: 14px;
        line-height: 30px;

        display: flex;
        align-items: center;

        color: #BDBDBD;
    }

    .help {
        margin-top: 50px;
    }

    span.input-group-addon i {
        color: #009edf;
        font-size: 17px;
    }

     @media(max-width: 768px){
          h5 {
        font-size: 24px;
        line-height: 35px;
        margin: 0px 0px;
    }

        .main-center{
      
        background: none;
        -webkit-box-shadow:0px 0px 0px rgba(107, 127, 153, 0.2);
        -moz-box-shadow:0px 0px 0px rgba(107, 127, 153, 0.2);
        box-shadow:0px 0px 0px rgba(107, 127, 153, 0.2);
        }

.btnSend {
    width: 100%;
    font-family: Muli-Bold;
    font-style: normal;
    font-size: 14px;
    line-height: 18px;
    letter-spacing: 0.3px;
    background: #2DB9D1;
    border-color: #2DB9D1 !important;
    border-radius: 18px;
    color: #FFFFFF;
    display: block;
    margin-top: 30px;
    padding: 13px 27px;
  }

  .btnSend:hover {
    color: #FFFFFF;
    background-color: #4F4C4C;
    border-color: #4d4c4f !important;
  }
        
     }
</style>